import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

function SparkMemoryReviewSkeleton() {
  return (
    <Grid
      item
      container
      bgcolor={(theme) => theme.palette.bgGray.main}
      borderRadius='10px'
      padding={2}
      xs={12}
      display={'flex'}
      flexDirection={'column'}
    >
      <Box display='flex' alignItems='center' width='100%'>
        <Skeleton variant='circular' width={43} height={40} />
        <Box pl={2} width='100%'>
          <Box>
            <Skeleton variant='text' sx={{ fontSize: '1rem' }} width={120} />
          </Box>
        </Box>
      </Box>
      <Box display={'flex'} alignItems={'center'}>
        <Skeleton variant='text' sx={{ fontSize: '20px' }} width={70} />
        <Skeleton
          variant='text'
          sx={{ fontSize: '1rem' }}
          width={60}
          style={{ marginLeft: '10px' }}
        />
      </Box>
      <Box>
        <Skeleton variant='text' sx={{ fontSize: '1rem' }} height={70} />
      </Box>
    </Grid>
  );
}

export default SparkMemoryReviewSkeleton;
